import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@pattern-library/buttons';
import PasswordReveal from '@pattern-library/password-reveal';
import useUnifiedLoginFormValidation from '../../hooks/useUnifiedLoginFormValidation';

const propTypes = {
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    ssnInputProps: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
    ).isRequired,
    formAction: PropTypes.string.isRequired,
    antiForgeryToken: PropTypes.string.isRequired
};

function ForgotUserIdForm(props) {
    const { buttonProps, ssnInputProps, formAction, antiForgeryToken } = props;

    const ssnInputName = ssnInputProps.name;
    const { hideAlertMessage, showAlertMessage, validation, ...restSsnInputProps } = ssnInputProps;

    /**
     * @type { import('@pattern-library/base/dist/js/hooks/useFormValidation').FormValidationSchema}
     */
    const schema = { [ssnInputName]: validation };

    const { hasError, onSubmit, errorMessage } = useUnifiedLoginFormValidation({ schema });

    return (
        <div className="ul-login-form">
            <form
                action={formAction}
                method="post"
                onSubmit={onSubmit}
                autoComplete="false"
                noValidate
            >
                <div dangerouslySetInnerHTML={{ __html: antiForgeryToken }} />
                <PasswordReveal
                    isRequired
                    preventAutofill
                    hasError={hasError(ssnInputName)}
                    errorMessage={errorMessage(ssnInputName)}
                    {...restSsnInputProps}
                    alertMessage={({ isHidden }) =>
                        isHidden ? hideAlertMessage : showAlertMessage
                    }
                />
                <ButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                    <Button type="submit" className="asc-mtb-0" {...buttonProps} />
                </ButtonGroup>
            </form>
        </div>
    );
}

ForgotUserIdForm.propTypes = propTypes;
export default ForgotUserIdForm;
